import produce from "immer";
import { RESET_ACTIVITY } from "./reset";

// Actions
export const RECORD = "questions/RECORD";

const initialState = {
  questions: {},
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  return produce(state, (draft) => {
    switch (action.type) {
      case RECORD: {
        const { answered, chosen, id, resetID } = action.props;

        if (!answered || !chosen || !id) {
          throw new Error(
            'must pass "id", "chosen" and "answered" to action props'
          );
        }

        if (!draft.questions) {
          draft.questions = {};
        }

        draft.questions[id] = { answered, chosen, resetID };

        break;
      }
      case RESET_ACTIVITY: {
        const { id } = action;

        if (!id) {
          break;
        }

        if (!draft.questions) {
          break;
        }

        for (let questionID in draft.questions) {
          // check also if property is not inherited from prototype
          if (draft.questions.hasOwnProperty(questionID)) {
            const { resetID } = state.questions[questionID];

            if (resetID == id) {
              draft.questions[questionID] = {
                answered: false,
                chosen: null,
                resetID,
              };
            }
          }
        }

        break;
      }
    }
  });
}

// Action Creators
/**
 *
 * @param {Object} props
 * @param {Boolean} props.answered - this question was answered
 * @param {string|number} props.chosen - id of the chosen answer
 * @param {string|number} props.id - id of the question
 * @param {string|number} props.resetID - optional ID to allow re-setting question
 */
export function setQuestion(props) {
  return { type: RECORD, props };
}

// selector
export function selectQuestions(state) {
  return state.questions;
}

export function selectQuestion(state, id) {
  const data = { answered: false, chosen: null };
  if (!state.questions?.questions) {
    return data;
  }
  return state.questions.questions[id] ?? data;
}
